export default "__VITE_ASSET__BFN30qND__"